import { FC } from 'react'

import { NewsEntryType, UnifiedNewsEntry } from '../../../../types/UnifiedNewsEntry'
import NewsCardLink from '../../NewsCardLink/NewsCardLink'
import './NewsCardCoverImage.scss'

type NewsCardCoverImageProps = {
  newsEntry: UnifiedNewsEntry
  altText?: string
  isInternalUser?: boolean
}
export const NewsCardCoverImage: FC<NewsCardCoverImageProps> = ({ newsEntry, altText, isInternalUser }) => {
  switch (newsEntry.feedEntry.type) {
    case NewsEntryType.Report:
      return (
        <div className="NewsCardCoverImage">
          {isInternalUser && <NewsCardLink newsEntry={newsEntry} sx={{ position: 'absolute' }} />}
          {newsEntry.feedEntry.entryData.coverUrls && newsEntry.feedEntry.entryData.coverUrls.length > 0 ? (
            <img src={newsEntry.feedEntry.entryData.coverUrls[0]} alt={altText} className="NewsCardCoverImage__image" />
          ) : null}
        </div>
      )
    default:
    case NewsEntryType.Editorial:
      return (
        <div className="NewsCardCoverImage">
          {isInternalUser && <NewsCardLink newsEntry={newsEntry} sx={{ position: 'absolute' }} />}
          {newsEntry.feedEntry.entryData.image ? (
            <img src={newsEntry.feedEntry.entryData.image.url} alt={altText} className="NewsCardCoverImage__image" />
          ) : null}
        </div>
      )
  }
}
